module.exports = __webpack_public_path__ + "static/media/older_woman_ipad.5a38417f.jpg";